import { Input, Optional, Directive, ElementRef } from '@angular/core';
import { D3ChartDirective, D3Element, D3MarginDirective } from './chart';
import { D3PieBase } from './pie';
import * as d3 from 'd3';


export class D3ArcDirective extends D3PieBase {
   name: string;
   transition = 'ease';
   duration = 500;
   value = 'value';
   label = 'label';
   dy = '0.35em';
   textAnchor = 'middle';
   innerRadius = 0.6;
   labelRadius = 0;

  private _center;
  private _arc;
  private _label;

  constructor(chart: D3ChartDirective, el: ElementRef,  margin?: D3MarginDirective) {
    super(chart, el, margin);
    this._center = d3.select(el.nativeElement).attr('class', 'arc');
    this._arc = this._center.append('path').attr('class', 'arc');
    this._label = this._center.append('text').attr('class', 'arc-label');
  }

  redraw() {
    super.redraw();
    const data = this.data;
    const radius = this.radius;
    const arc = this.createArc(radius);
    const arcTween = this.createArcTween(arc, 0);

    this._center.attr('transform', `translate(${radius},${radius})`);

    this._label.attr('dy', this.dy).style('text-anchor', 'middle').text(data[this.label]);

    this._arc.datum(data[this.value])
      .transition().ease(this.transition).duration(this.duration)
      .attrTween('d', arcTween);
  }

  createArc(radius: number) {
     return super.createArc(radius).startAngle(0)
      .endAngle(d => (d / 100) * 2 * Math.PI);
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[d3-arc]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: D3ChartDirective, },
{type: ElementRef, },
{type: D3MarginDirective, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'name': [{ type: Input },],
'transition': [{ type: Input },],
'duration': [{ type: Input },],
'value': [{ type: Input },],
'label': [{ type: Input },],
'dy': [{ type: Input },],
'textAnchor': [{ type: Input, args: ['text-anchor', ] },],
'innerRadius': [{ type: Input, args: ['inner-radius', ] },],
'labelRadius': [{ type: Input, args: ['label-radius', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
